import { IAutoCompleteSearchResult } from '@smiles/smiles-ui-kit-react';
import { AirportData } from '@smiles/core-airlines/dist/Types/Airports.types';

export type IFlightType = 'ROUND_TRIP' | 'ONE_WAY' | 'MULTI_CITY';
export type IFlightClass = 'ALL' | 'ECONOMIC' | 'BUSINESS';
export type IModalType =
  | 'generalErrorModal'
  | 'invalidMultiCityModal'
  | 'sameDayFlightModal'
  | 'internationalSameDayFlightModal';

export interface IListItem<T> {
  translationKey: string;
  icon: JSX.Element;
  value: T;
  description?: string;
}

export interface ISearchFlight {
  firstLeg?: ICustomAutoCompleteSearch;
  secondLeg?: ICustomAutoCompleteSearch;
}
export interface ISearchFlightLegacy {
  tooltipcount: number;
  tripType: number;
  adults: number;
  children: number;
  totalPassenger: number;
  departureDay1: number;
  departureDay2: number;
  returnDay: number;
  originAirport: string;
  destinAirport: string;
  tripOAirport: string | null;
  tripDAirport: string | null;
  changeDestination: null;
  flexibleDate: boolean;
  isFlexibleDateChecked: boolean;
  flexibleDateOptions: null;
  dataAirportOrigin: Array<string>;
  dataAirportDeparture: Array<string>;
  inputOrigin: string;
  inputDestination: string;
  inputOriginMs2: string;
  inputDestinationMs2: string;
  singleLeg: boolean;
  departureDate: string;
  returnDate: string;
  qtdAdult: number;
  qtdChild: number;
  qtdBaby: number;
  cabin: cabinTypesList;
}
export interface ISearchDate {
  firstFlight?: { departureDate: Date; returnDate?: Date };
  secondFlightDate?: Date;
}

export interface IFlightPassagers {
  adults: number;
  children: number;
  babies: number;
}
export interface IGetCounterItems {
  t(key: string): string;
  adultsValue: number;
  childrenValue: number;
  babiesValue: number;
}

export interface ICounterItems {
  counterName: string;
  min: number;
  name: string;
  defaultValue?: number;
}

export interface ISearchErrors {
  firstLeg?: {
    origin?: boolean;
    destination?: boolean;
    date?: boolean;
  };
  secondLeg?: {
    origin?: boolean;
    destination?: boolean;
    date?: boolean;
  };
}

export interface IIsValidMobileSearch {
  origins: ISearchFlight | undefined;
  destinations: ISearchFlight | undefined;
  dates: ISearchDate | undefined;
  isMultiCityFlight: boolean;
}

export interface IGetAirportFormattedValue {
  flight: ISearchFlight | undefined;
  isFirstLeg: boolean;
}

export interface IGenerateSearchURL {
  origins: ISearchFlight;
  destinations: ISearchFlight;
  flightType: IFlightType;
  flightClass: IFlightClass;
  isMultiCityFlight: boolean;
  flightDates: ISearchDate;
  flightPassagers: IFlightPassagers;
}

export interface ISubmitSearch {
  ignoreSameDayFlightModal?: boolean;
  isCrossSellChecked?: boolean;
}

export interface IInfoModal {
  isOpen: boolean;
  translationKey: IModalType;
}

export interface ICustomAutoCompleteSearch
  extends AirportData,
    IAutoCompleteSearchResult {}

export enum flightTypesList {
  ROUND_TRIP = 'ROUND_TRIP',
  ONE_WAY = 'ONE_WAY',
  MULTI_CITY = 'MULTI_CITY',
}

export enum flightClassesList {
  ALL = 'ALL',
  ECONOMIC = 'ECONOMIC',
  BUSINESS = 'BUSINESS',
}

export enum cabinTypesList {
  ALL = 'ALL',
  ECONOMIC = 'ECONOMIC',
  BUSINESS = 'BUSINESS',
}

export enum flightClassesTranslation {
  ALL_CLASSES = 'allClasses',
  ECONOMIC = 'economy',
  BUSINESS = 'business',
}

export enum getModalType {
  GENERAL_ERROR = 'generalErrorModal',
  INVALID_MULTICITY = 'invalidMultiCityModal',
  SAME_DAY = 'sameDayFlightModal',
  SAME_DAY_INTERNATIONAL = 'internationalSameDayFlightModal',
}

export type IDirection = 'origin' | 'destination';

export type FilterProps = {
  lat: number;
  long: number;
};

export type SearchAirportProps = {
  filter?: {
    field: string;
    value: string;
    itemType?: string;
  };
  location?: {
    latitude: number;
    longitude: number;
  };
};

export type DataLayerInfo = {
  departureCountry?: string;
  returnCountry?: string;
  flightType: IFlightType;
  flightPassengers: IFlightPassagers;
  departureDate?: Date;
  returnDate?: Date;
  title?: string;
};
